import { GlobalAssortmentPage } from '@/pages/global-assortment'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/p/products/')({
	component: GlobalAssortmentPage,
})
